import Vue from 'vue';
Vue.directive('isNumber', (el: any, binding: any) => {
  const i = /(\d+(\.\d+)?)/i.test(el.value);
  if (!i) {
    const newValue = el.value.replace(/[a-zA-Z]+/gi, '');
    el.value = newValue;
    binding.value = el.value;
  }
});
